import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { axiosInstance } from "../../axios-instance";
import { qsOptions } from "../qsOptions";
import type { R } from "../types";
import type {
  IDeleteContractingCompanyRequest,
  IDeleteContractingCompanyResponse,
  IGetContractingCompaniesRequest,
  IGetContractingCompaniesResponse,
  IGetContractingCompanyByIdRequest,
  IGetContractingCompanyByIdResponse,
  IUpdateContractingCompanyLogoRequest,
  IUpdateContractingCompanyLogoResponse,
  IUpsertContractingCompanyRequest,
  IUpsertContractingCompanyResponse,
} from "./types";

export class ContractingCompaniesService {
  async getAll(
    p: IGetContractingCompaniesRequest,
    c?: AxiosRequestConfig,
  ): R<IGetContractingCompaniesResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/contractingCompany/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getCompanyDetails(
    p: IGetContractingCompanyByIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetContractingCompanyByIdResponse> {
    try {
      return axiosInstance.get(`/api/contractingCompany/${p.id}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async upsertCompany(
    p: IUpsertContractingCompanyRequest,
    c?: AxiosRequestConfig,
  ): R<IUpsertContractingCompanyResponse> {
    try {
      return axiosInstance.post(`/api/contractingCompany/saveOrUpdate`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteCompany(
    p: IDeleteContractingCompanyRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteContractingCompanyResponse> {
    try {
      return axiosInstance.delete(`/api/contractingCompany/${p.id}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateLogo(
    p: IUpdateContractingCompanyLogoRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateContractingCompanyLogoResponse> {
    try {
      return axiosInstance.put(
        `/api/contractingCompany/updateLogo/${p.id}`,
        p.formData,
        {
          ...c,
          headers: {
            ...c?.headers,
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
